export default "__VITE_ASSET__CUFwMg6f__"